import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { DialogData } from 'app/reports/reportdialog';
import { ExportService } from 'app/reports/services/export.service';
import { PatientTrackingModel } from 'app/table-list/Models/patient_tracking.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-patient-tracking',
  templateUrl: './patient-tracking.component.html',
  styleUrls: ['./patient-tracking.component.scss']
})
export class PatientTrackingComponent implements OnInit {
  destroytracking$: Subject<boolean> = new Subject<boolean>();
  visitselected = -1;
  displayedColumns: string[] = ['SrNo', 'AdmitTime', 'PatientId', 'PatientName', 'DoctorName', 'CaseType', 'OtGroup', 'TheatreName', 'DisTime', 'PostPoneReason', 'PatientRemark', 'sendForFinacial', 'Finacial_c_done', 'EnteredInWard', 'PreopMedication', 'PacDone', 'SendToOT', 'ReceiveFromOT', 'FinalBilling', 'FinalBillingdone', 'dischargeSummery', 'Total'];
  tracking_details: PatientTrackingModel[] = [];
  dataSource;
  firstvisitdate;

  constructor(private authService: AuthService,
    private http: HttpClient, private dashBoardService: DashboardService, private dialogRef: MatDialogRef<PatientTrackingComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private datePipe: DatePipe, private ipdservice: IPDService, private exportdata: ExportService) { }

  ngOnInit() {
    this.visitselected =-1;
    this.tracking_details=[];
    this.firstvisitdate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.get_patient_tracking(this.firstvisitdate);
  }
  ngOnDestroy(): void {
    this.destroytracking$.next(true);
    this.destroytracking$.unsubscribe();
    this.visitselected = null;
    this.tracking_details = null;
    this.firstvisitdate = null;
    this.dataSource = null;
    this.displayedColumns = null;
   
}
  apptexportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('contentap');
    this.exportdata.Newexportxcel(element, 'Patient_IPD_Tracking');
  }
  changeDate() {

    this.firstvisitdate = this.datePipe.transform(this.firstvisitdate, "yyyy-MM-dd");
    this.get_patient_tracking(this.firstvisitdate);
  }
 
  get_patient_tracking(firstvisitdate: string) {
    this.ipdservice.InserttrackingData(this.authService.Loggeduser.branchid, firstvisitdate, firstvisitdate).pipe(takeUntil(this.destroytracking$)).subscribe((x: any) => {
      this.dataSource = x;
    }, err => {
      this.dashBoardService.openSnackBar("API Failed", "ok")
    })

  }


  keyDownFunction(event) {

    if (event.keyCode === 27) {
      this.dialogRef.close();
    }

  }

}
